import React from 'react';
import { debounce } from 'lodash';
import { PropTypes, describe } from 'react-desc';
import { TooltipTextProvider } from '@elliemae/ds-basic/TruncatedTooltipText';
import ShuttleImpl from './ShuttleImpl.js';
export { default as utils } from './utils.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '@babel/runtime/helpers/esm/toConsumableArray';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@babel/runtime/helpers/esm/defineProperty';
import '@elliemae/ds-utilities/utils';
import './withProviders.js';
import './AnimationState.js';
import '@babel/runtime/helpers/esm/slicedToArray';
import 'constate';
import './SearchState.js';
import './ShuttleState.js';
import './helper.js';
import 'treetabular';
import './Shuttle.actions.js';
import './ShuttleRenderer.js';
import './components/ShuttleSource.js';
import 'prop-types';
import '@elliemae/ds-icons/ArrowShortRight';
import '@elliemae/ds-basic/Button';
import '@elliemae/ds-icons/Search';
import './components/ShuttleSearchBox.js';
import '@elliemae/ds-classnames';
import '@elliemae/ds-basic/form/TextBox';
import './components/ShuttleInfiniteScrollIndicator.js';
import '@elliemae/ds-basic/IndeterminateProgressIndicator';
import './components/ShuttleListItem/ShuttleSourceListItem.js';
import './components/ShuttleListItem/ActionButtons.js';
import '@elliemae/ds-icons/CloseCircle';
import '@elliemae/ds-icons/ArrowShortReturn';
import './components/ShuttleListItem/ShuttleListItem.js';
import 'react-spring/web.cjs';
import 'react-sortable-hoc';
import '@elliemae/ds-icons/GripperVertical';
import './classedComponents.js';
import './components/ShuttleBreadcrumb.js';
import '@elliemae/ds-basic/Breadcrumb';
import './animation/animationConfig.js';
import './components/OverflowList.js';
import './components/ShuttleListPanel.js';
import './components/VirtualizedList.js';
import 'react-window';
import 'react-window-infinite-loader';
import 'react-virtualized-auto-sizer';
import './components/VirtualizedItem.js';
import './components/VirtualizedSortableList.js';
import './components/LoadingIndicator.js';
import '@elliemae/ds-basic/CircularProgressIndicator';
import 'styled-components';
import './components/ShuttleTarget.js';
import './components/ShuttleListItem/ShuttleTargetListItem.js';
import './updateShuttleStateFromProps.js';

/* eslint-disable max-lines */

var noop = function noop() {};

var DSShuttle = function DSShuttle(_ref) {
  var _ref$containerProps = _ref.containerProps,
      containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
      _ref$idField = _ref.idField,
      idField = _ref$idField === void 0 ? 'id' : _ref$idField,
      _ref$parentIdField = _ref.parentIdField,
      parentIdField = _ref$parentIdField === void 0 ? 'parent' : _ref$parentIdField,
      _ref$showIcons = _ref.showIcons,
      showIcons = _ref$showIcons === void 0 ? true : _ref$showIcons,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$selectedItems = _ref.selectedItems,
      selectedItems = _ref$selectedItems === void 0 ? undefined : _ref$selectedItems,
      _ref$nonSelectedItems = _ref.nonSelectedItems,
      nonSelectedItems = _ref$nonSelectedItems === void 0 ? undefined : _ref$nonSelectedItems,
      _ref$onSearch = _ref.onSearch,
      onSearch = _ref$onSearch === void 0 ? noop : _ref$onSearch,
      _ref$onSearchOpen = _ref.onSearchOpen,
      onSearchOpen = _ref$onSearchOpen === void 0 ? noop : _ref$onSearchOpen,
      _ref$onSearchClose = _ref.onSearchClose,
      onSearchClose = _ref$onSearchClose === void 0 ? noop : _ref$onSearchClose,
      _ref$onDrillDown = _ref.onDrillDown,
      onDrillDown = _ref$onDrillDown === void 0 ? noop : _ref$onDrillDown,
      _ref$onDrillDownTarge = _ref.onDrillDownTarget,
      onDrillDownTarget = _ref$onDrillDownTarge === void 0 ? noop : _ref$onDrillDownTarge,
      _ref$onTargetSortEnd = _ref.onTargetSortEnd,
      onTargetSortEnd = _ref$onTargetSortEnd === void 0 ? noop : _ref$onTargetSortEnd,
      _ref$setGetStatus = _ref.setGetStatus,
      setGetStatus = _ref$setGetStatus === void 0 ? noop : _ref$setGetStatus,
      _ref$targetSortable = _ref.targetSortable,
      targetSortable = _ref$targetSortable === void 0 ? true : _ref$targetSortable,
      _ref$sourceEmptyMessa = _ref.sourceEmptyMessage,
      sourceEmptyMessage = _ref$sourceEmptyMessa === void 0 ? 'No Items Found' : _ref$sourceEmptyMessa,
      _ref$sourceRootTitle = _ref.sourceRootTitle,
      sourceRootTitle = _ref$sourceRootTitle === void 0 ? 'Category' : _ref$sourceRootTitle,
      _ref$targetEmptyMessa = _ref.targetEmptyMessage,
      targetEmptyMessage = _ref$targetEmptyMessa === void 0 ? 'No Items Selected' : _ref$targetEmptyMessa,
      _ref$targetRootTitle = _ref.targetRootTitle,
      targetRootTitle = _ref$targetRootTitle === void 0 ? 'Selected Items' : _ref$targetRootTitle,
      _ref$composeSourceIte = _ref.composeSourceItemProps,
      composeSourceItemProps = _ref$composeSourceIte === void 0 ? function () {
    return {};
  } : _ref$composeSourceIte,
      _ref$composeTargetIte = _ref.composeTargetItemProps,
      composeTargetItemProps = _ref$composeTargetIte === void 0 ? function () {
    return {};
  } : _ref$composeTargetIte,
      _ref$onAddToTarget = _ref.onAddToTarget,
      onAddToTarget = _ref$onAddToTarget === void 0 ? noop : _ref$onAddToTarget,
      _ref$onAddCheckedItem = _ref.onAddCheckedItems,
      onAddCheckedItems = _ref$onAddCheckedItem === void 0 ? noop : _ref$onAddCheckedItem,
      _ref$onRemoveFromTarg = _ref.onRemoveFromTarget,
      onRemoveFromTarget = _ref$onRemoveFromTarg === void 0 ? noop : _ref$onRemoveFromTarg,
      _ref$onRemoveAllFromT = _ref.onRemoveAllFromTarget,
      onRemoveAllFromTarget = _ref$onRemoveAllFromT === void 0 ? noop : _ref$onRemoveAllFromT,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
      _ref$renderSourceCoun = _ref.renderSourceCounter,
      renderSourceCounter = _ref$renderSourceCoun === void 0 ? noop : _ref$renderSourceCoun,
      _ref$renderTargetCoun = _ref.renderTargetCounter,
      renderTargetCounter = _ref$renderTargetCoun === void 0 ? noop : _ref$renderTargetCoun,
      _ref$sourceClearItems = _ref.sourceClearItemsText,
      sourceClearItemsText = _ref$sourceClearItems === void 0 ? 'CLEAR ALL' : _ref$sourceClearItems,
      _ref$targetClearItems = _ref.targetClearItemsText,
      targetClearItemsText = _ref$targetClearItems === void 0 ? 'CLEAR ALL' : _ref$targetClearItems,
      _ref$searchPlaceholde = _ref.searchPlaceholder,
      searchPlaceholder = _ref$searchPlaceholde === void 0 ? 'Search field ID, name, etc.' : _ref$searchPlaceholde,
      _ref$loadingSource = _ref.loadingSource,
      loadingSource = _ref$loadingSource === void 0 ? false : _ref$loadingSource,
      _ref$loadingTarget = _ref.loadingTarget,
      loadingTarget = _ref$loadingTarget === void 0 ? false : _ref$loadingTarget,
      _ref$onGetMoreItems = _ref.onGetMoreItems,
      onGetMoreItems = _ref$onGetMoreItems === void 0 ? function () {
    return null;
  } : _ref$onGetMoreItems,
      _ref$hasNextPage = _ref.hasNextPage,
      hasNextPage = _ref$hasNextPage === void 0 ? false : _ref$hasNextPage,
      moreItemsLoading = _ref.moreItemsLoading;
  return /*#__PURE__*/React.createElement(TooltipTextProvider, null, /*#__PURE__*/React.createElement(ShuttleImpl, {
    composeSourceItemProps: composeSourceItemProps,
    composeTargetItemProps: composeTargetItemProps,
    containerProps: containerProps,
    idField: idField,
    items: items,
    onAddCheckedItems: onAddCheckedItems,
    onAddToTarget: onAddToTarget,
    onChange: onChange,
    onDrillDown: onDrillDown,
    nonSelectedItems: nonSelectedItems,
    onDrillDownTarget: onDrillDownTarget,
    onRemoveAllFromTarget: onRemoveAllFromTarget,
    onRemoveFromTarget: onRemoveFromTarget,
    onSearch: onSearch,
    onSearchClose: onSearchClose,
    onSearchOpen: onSearchOpen,
    onTargetSortEnd: onTargetSortEnd,
    parentIdField: parentIdField,
    renderSourceCounter: renderSourceCounter,
    renderTargetCounter: renderTargetCounter,
    searchPlaceholder: searchPlaceholder,
    selectedItems: selectedItems,
    setGetStatus: setGetStatus,
    showIcons: showIcons,
    sourceClearItemsText: sourceClearItemsText,
    sourceEmptyMessage: sourceEmptyMessage,
    sourceRootTitle: sourceRootTitle,
    targetClearItemsText: targetClearItemsText,
    targetEmptyMessage: targetEmptyMessage,
    targetRootTitle: targetRootTitle,
    targetSortable: targetSortable,
    loadingSource: loadingSource,
    loadingTarget: loadingTarget,
    onGetMoreItems: debounce(function () {
      onGetMoreItems.apply(void 0, arguments);
    }, 500),
    moreItemsLoading: moreItemsLoading,
    hasNextPage: hasNextPage
  }));
};

var props = {
  /** inject props to shuttle wrapper */
  containerProps: PropTypes.object.description('inject props to shuttle wrapper'),

  /** The identifier field for the item object */
  idField: PropTypes.string.description('The identifier field for the item object'),

  /** The parent identifier field for the item object */
  parentIdField: PropTypes.string.description('The parent identifier field for the item object'),

  /** Whether to show the icons or not */
  showIcons: PropTypes.string.description('Whether to show the icons or not'),

  /** List of items */
  items: PropTypes.arrayOf(PropTypes.shape({
    disableDrillDown: PropTypes.bool,
    icon: PropTypes.element,
    name: PropTypes.string,
    readOnly: PropTypes.bool,
    description: PropTypes.string
  })).description('list of items'),

  /** Array of item ids that are selected. If passed the component behaves as controlled */
  selectedItems: PropTypes.arrayOf(PropTypes.string).description('Array of item ids that are selected. If passed the component behaves as controlled'),

  /** Array of item ids that aren't selected. Should include ALL non selected items, even those not rendered */
  nonSelectedItems: PropTypes.arrayOf(PropTypes.string).description("Array of item ids that aren't selected.. Should include ALL non selected items, even those not rendered"),

  /** Handler on search */
  onSearch: PropTypes.func.description('Handler on search'),

  /** Handler when the searchbox is visible */
  onSearchOpen: PropTypes.func.description('Handler when the searchbox is visible'),

  /** Handler when the searchbox is not visible */
  onSearchClose: PropTypes.func.description('Handler when the searchbox is not visible'),

  /** Source handler when a user navigates to a level down on the nested structure. First param: item drilled. Second param: direction ("up" | "down")  */
  onDrillDown: PropTypes.func.description('Source handler when a user navigates to a level down on the nested structure. First param: item drilled. Second param: direction ("up" | "down")'),

  /** Target handler when a user navigates to a level down on the nested structure. First param: item drilled. Second param: direction ("up" | "down") */
  onDrillDownTarget: PropTypes.func.description('Target handler when a user navigates to a level down on the nested structure. First param: item drilled. Second param: direction ("up" | "down")'),

  /** Target handler when user stops dragging an item */
  onTargetSortEnd: PropTypes.func.description('Target handler when user stops dragging an item'),

  /** Callback function that gets more items for Infinite Scroll */
  onGetMoreItems: PropTypes.func.description('Callback function that gets more items for Infinite Scroll'),

  /** Wheter there are mor items loading for Infinite Scroll */
  moreItemsLoading: PropTypes.bool.description('Wheter there are mor items loading for Infinite Scroll'),

  /** Wheter there is a next page for Infinite Scroll, controls when to trigger onGetMoreItems */
  hasNextPage: PropTypes.bool.description('Wheter there is a next page for Infinite Scroll, controls when to trigger onGetMoreItems'),

  /** Function that takes as a parameter an internal getter for the state */
  setGetStatus: PropTypes.func.description('Function that takes as a parameter an internal getter for the state'),

  /** Whether the target can be sortable with DnD */
  targetSortable: PropTypes.bool.description('Whether the target can be sortable with DnD'),

  /** Handler when the searchbox is visible */
  sourceRootTitle: PropTypes.string.description('Handler when the searchbox is visible'),

  /** Source text when there is no items */
  sourceEmptyMessage: PropTypes.string.description('Source text when there is no items'),

  /** Target text when there is no items */
  targetEmptyMessage: PropTypes.string.description('Target text when there is no items'),

  /** Target text for the first hierarchy item */
  targetRootTitle: PropTypes.string.description('Target text for the first hierarchy item'),

  /** Function that allow to compose the item props in the source */
  composeSourceItemProps: PropTypes.func.description('Function that allow to compose the item props in the source'),

  /** Function that allow to compose the item props in the target */
  composeTargetItemProps: PropTypes.func.description('Function that allow to compose the item props in the target'),

  /** Handler when a users moves an item to the target */
  onAddToTarget: PropTypes.func.description('Handler when a users moves an item to the target'),

  /** Handler when a users moves all the 'checked' items to the target */
  onAddCheckedItems: PropTypes.func.description("Handler when a users moves all the 'checked' items to the target"),

  /** Handler when a user removes an item from the target */
  onRemoveFromTarget: PropTypes.func.description('Handler when a user removes an item from the target'),

  /** Handler when a user removes all the items from the target */
  onRemoveAllFromTarget: PropTypes.func.description('Handler when a user removes all the items from the target'),

  /** Handler for every change on the state */
  onChange: PropTypes.func.description('Handler for every change on the state'),

  /** Function that returns an element for the source counter */
  renderSourceCounter: PropTypes.func.description('Function that returns an element for the source counter'),

  /** Function that returns an element for the target counter */
  renderTargetCounter: PropTypes.func.description('Function that returns an element for the target counter'),

  /** Source text for the clear items button */
  sourceClearItemsText: PropTypes.string.description('Source text for the clear items button'),

  /** Target text for the clear items button */
  targetClearItemsText: PropTypes.string.description('Target text for the clear items button'),

  /** Searchbox placeholder */
  searchPlaceholder: PropTypes.string.description('Searchbox placeholder'),

  /** Displays loading indicator on source section */
  loadingSource: PropTypes.bool.description('Displays loading indicator on source section'),

  /** Displays loading indicator on target section */
  loadingTarget: PropTypes.bool.description('Displays loading indicator on target section')
};
DSShuttle.propTypes = props;
var DSShuttleWithSchema = describe(DSShuttle);
DSShuttleWithSchema.propTypes = props;

export default DSShuttle;
export { DSShuttleWithSchema };
//# sourceMappingURL=DSShuttle.js.map
